import { Seo } from "@/components/Seo";
import { useReveals } from "@/lib/motion";
import { Capabilities } from "@/sections/Capabilities";
import { Chain } from "@/sections/Chain";
import { Converge } from "@/sections/Converge";
import { Faq } from "@/sections/Faq";
import { Hero } from "@/sections/Hero";
import { Method } from "@/sections/Method";
import { PitSequence } from "@/sections/PitSequence";

export default function Home() {
  const scope = useReveals();

  return (
    <div ref={scope}>
      <Seo
        title="MineOptics | Open-pit mining cost modelling"
        description="From drillhole data to a costed scenario you can issue as a report. Mine plan, drill and blast, fleet, plant and overheads for open-pit mining, with every formula published."
        path="/"
      />
      <Hero />
      <PitSequence />
      <Method />
      <Converge />
      <Capabilities />
      <Chain />
      <Faq />
    </div>
  );
}
